<script setup lang="ts">

</script>

<template>
  <div>
    <footer class="footer">
      <div class="container">
        <div class="clearfix">
          <div class="footer-left">
            <div class="footer-logo">
              <router-link to="/" title="植根法律網">
                <img src="~/assets/images/logo-white.svg" alt="植根法律網">
              </router-link>
            </div>
            <div class="footer-slogan">
              讓我們一起努力 做一些植根的工作 把公平播向四方
            </div>
          </div>
          <div class="footer-right">
            <div class="footer-companyInfo">
              106 臺北市信義路三段 162-12 號玫瑰大廈 3 樓
            </div>
            <div class="footer-companyInfo">
              電話：02-2707-2848 傳真：02-2708-4428
            </div>
          </div>
        </div>
        <div class="copyright">
          COPYRIGHT (C) 2000-2003 ROOTLAW ALL RIGHTS RESERVED
        </div>
      </div>
    </footer>

    <div class="footer-fixed clearfix centerType">
      <transition name="el-zoom-in-bottom">
        <div v-if="false" class="footer-fixed-btn">
          <i class="fas fa-chevron-circle-down" />
        </div>
      </transition>

      <transition name="el-zoom-in-bottom">
        <div v-if="false" class="footer-fixed-btn">
          <i class="fas fa-question-circle" />
        </div>
      </transition>
    </div>
  </div>
</template>
